import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { X, Cookie } from "lucide-react";

const STORAGE_KEY = "rc_cookie_consent_v1";

export default function CookieBanner() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const v = localStorage.getItem(STORAGE_KEY);
    if (!v) {
      // Tiny delay so it doesn't flash on initial render
      const t = setTimeout(() => setShow(true), 600);
      return () => clearTimeout(t);
    }
  }, []);

  const accept = () => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify({ choice: "accept", ts: Date.now() }));
    setShow(false);
  };

  const declineNonEssential = () => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify({ choice: "essential_only", ts: Date.now() }));
    setShow(false);
  };

  if (!show) return null;

  return (
    <div
      role="dialog"
      aria-label="Cookie consent"
      data-testid="cookie-banner"
      className="fixed bottom-4 left-4 right-4 md:left-auto md:right-6 md:bottom-6 md:max-w-md z-[1200] rounded-lg border border-line bg-deep text-ice shadow-2xl"
    >
      <div className="p-5 md:p-6">
        <div className="flex items-start gap-3">
          <div className="w-9 h-9 rounded-full bg-sky/15 inline-flex items-center justify-center shrink-0">
            <Cookie className="w-4 h-4 text-sky" />
          </div>
          <div className="flex-1 min-w-0">
            <div className="font-display font-bold text-ice text-base">We use cookies</div>
            <p className="text-slate text-[13px] leading-relaxed mt-1.5">
              Railway Careers UK uses essential cookies to keep you signed in and
              optional analytics cookies (PostHog) to understand how the site is
              used. See our <Link to="/privacy" className="underline hover:text-ice">Privacy Policy</Link> for details.
            </p>
          </div>
          <button
            onClick={declineNonEssential}
            aria-label="Dismiss"
            className="text-slate hover:text-ice shrink-0"
            data-testid="cookie-close"
          >
            <X className="w-4 h-4" />
          </button>
        </div>
        <div className="mt-4 flex flex-col sm:flex-row gap-2">
          <button
            onClick={accept}
            className="flex-1 px-4 py-2.5 rounded-full bg-sky text-deep font-semibold text-[13px] hover:bg-ice transition-colors"
            data-testid="cookie-accept"
          >
            Accept all
          </button>
          <button
            onClick={declineNonEssential}
            className="flex-1 px-4 py-2.5 rounded-full bg-transparent border border-line text-ice font-semibold text-[13px] hover:border-sky transition-colors"
            data-testid="cookie-essential"
          >
            Essential only
          </button>
        </div>
      </div>
    </div>
  );
}
